import { FC, ReactNode } from 'react';

import { TeliaThemeProvider } from '@telialt/common-theme/src/TeliaThemeProvider';

export const LeadProvider: FC<{ children?: ReactNode }> = ({ children }) => {
    return <TeliaThemeProvider>{children}</TeliaThemeProvider>;
};
